export default "__VITE_ASSET__BXoS3xKE__"